import { Component, NgZone, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Md5 } from 'ts-md5/dist/md5';
import { AuthServiceService } from '../../core/http/auth-service.service';

const MD5 = new Md5();

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  isLoading = false;
  loginErrors = null;
  data = null;
  mode = 'login';
  clicked = false;
  SignLoading = false;
  password;
  selected = 'Patient';
  role = localStorage.getItem('role');
  show = false;
  location: string = '';
  showDropdown: boolean = true;

  forgot() {
    this.mode = 'pass';
  }
  switch() {
    this.show = !this.show;
  }

  login() {
    this.mode = 'login';
  }

  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  SignUpForm = new FormGroup({
    Employee_id: new FormControl(''),
    First_Name: new FormControl('', Validators.required),
    Middle_Name: new FormControl(''),
    Last_Name: new FormControl(''),
    U_Name: new FormControl('', Validators.required),
    Position_Id: new FormControl(23),
    Address: new FormControl(''),
    Phone_No: new FormControl('', Validators.required),
    Email_id: new FormControl('', Validators.required),
    Flag: new FormControl('', Validators.required),
    designation: new FormControl(''),
    signature: new FormControl(''),
    password: new FormControl('', Validators.required),
    IsDeleted: new FormControl(''),
    qualification: new FormControl(''),
    CanAuthDiscount: new FormControl(''),
  });

  constructor(
    public auth: AuthServiceService,
    public router: Router,
    private zone: NgZone,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    // Check for saved location when component loads
    const savedLocation = localStorage.getItem('selectedLocation');
    if (savedLocation) {
      this.location = savedLocation;
      this.showDropdown = false;
    }
  }

  onLocationSelect(selectedValue: string) {
    if (selectedValue) {
      // Save to localStorage
      localStorage.setItem('selectedLocation', selectedValue);
      // Hide the dropdown
      this.showDropdown = false;
    }
  }

  logins() {
    this.mode = 'login';
  }
  signup() {
    this.mode = 'signup';
  }

  submit() {
    this.SignLoading = true;
    console.log(this.SignUpForm.value);
    const {
      Employee_id,
      First_Name,
      Middle_Name,
      Last_Name,
      U_Name,
      Position_Id,
      Address,
      Phone_No,
      Email_id,
      Flag,
      designation,
      signature,
      password,
      IsDeleted,
      qualification,
      CanAuthDiscount,
    } = this.SignUpForm.value;
    this.auth
      .SignUp(
        Employee_id,
        First_Name,
        Middle_Name,
        Last_Name,
        Email_id,
        Position_Id,
        Address,
        Phone_No,
        Email_id,
        Flag,
        designation,
        signature,
        password,
        IsDeleted,
        qualification,
        CanAuthDiscount
      )
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.SignLoading = false;

          console.log('user object', this.data);
          if (this.data.success) {
            console.log(this.data);

            let password = MD5.appendStr(this.data.pasword).end();
            let username = this.data.usr.U_Name;

            this.auth.loginOnline(username, password).subscribe(
              (resSuccess) => {
                this.data = resSuccess;
                this.isLoading = false;

                console.log('user object', this.data);
                if (this.data.success) {
                  localStorage.setItem('token', this.data.userobj.user_token);
                  localStorage.setItem('id', this.data.userobj.userid);
                  localStorage.setItem('username', this.data.userobj.username);
                  this.auth.setLogedin(true);
                  this._snackBar.open('Logged in succesfully', '', {
                    duration: 2000,
                    verticalPosition: 'top',
                  });
                  window.location.href = `/profile`;
                  // this.router.navigateByUrl('/profile');
                  if (this.data.userobj.rolename) {
                    localStorage.setItem('role', this.data.userobj.rolename);
                  } else {
                    localStorage.setItem('role', this.data.userobj.designation);
                  }
                } else {
                  this._snackBar.open(this.data.message, '', {
                    duration: 2000,
                    verticalPosition: 'top',
                  });
                  this.isLoading = false;
                  this.loginForm.reset();
                }
              },
              (resErr) => {
                this._snackBar.open(resErr, '', {
                  duration: 2000,
                  verticalPosition: 'top',
                });
                this.isLoading = false;
                this.loginForm.reset();
              }
            );
          } else {
            this._snackBar.open(this.data.message, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            this.SignLoading = false;
            this.loginForm.reset();
          }
        },
        (resErr) => {
          this._snackBar.open(resErr, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.SignLoading = false;
          this.loginForm.reset();
        }
      );
  }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.loginErrors = null;
    console.log(this.selected);

    let { username, password } = this.loginForm.value;

    if (!this.clicked) {
      this.password = MD5.appendStr(password).end();
    } else {
    }
    this.clicked = true;
    //this.password =  MD5.appendStr(password).end();

    if (this.selected == 'Patient') {
      this.auth.loginOnline(username, this.password).subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.isLoading = false;

          console.log('user object', this.data);
          if (this.data.success) {
            localStorage.setItem('token', this.data.userobj.user_token);
            localStorage.setItem('id', this.data.userobj.userid);
            localStorage.setItem('username', this.data.userobj.username);
            this.auth.setLogedin(true);
            window.location.href = '/profile';
            // this.router.navigateByUrl('/profile');
            if (this.data.userobj.rolename) {
              localStorage.setItem('role', this.data.userobj.rolename);
            } else {
              localStorage.setItem('role', this.data.userobj.designation);
            }
          } else {
            this.loginErrors = this.data.message;
            this._snackBar.open(this.data.message, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            console.log(this.data.message);
          }
        },
        (resErr) => {
          this.isLoading = false;
          this._snackBar.open(resErr, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.loginErrors = resErr;
        }
      );
    } else if (this.selected == 'Offline') {
      // console.log(password);
      // let hashedPassword1 =  MD5.appendStr(password).end();
      // console.log(hashedPassword1);
      const CryptoJS = require('crypto-js');
      let hashedPassword = CryptoJS.MD5(password).toString();
      console.log(hashedPassword);
      this.auth.login(username, hashedPassword).subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.isLoading = false;

          console.log('user object', this.data);
          if (this.data.success) {
            localStorage.setItem('token', this.data.userobj.user_token);
            localStorage.setItem('id', this.data.userobj.userid);
            localStorage.setItem('username', this.data.userobj.username);
            this.auth.setLogedin(true);
            localStorage.setItem('user', this.data.userobj);

            window.location.href = '/profile';
            // this.router.navigateByUrl('/profile');
            if (this.data.userobj.rolename) {
              localStorage.setItem('role', this.data.userobj.rolename);
            } else {
              localStorage.setItem('role', this.data.userobj.designation);
            }
          } else {
            this.loginErrors = this.data.message;
            this._snackBar.open(this.data.message, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            console.log(this.data.message);
          }
        },
        (resErr) => {
          this.isLoading = false;
          this._snackBar.open(resErr, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.loginErrors = resErr;
        }
      );
    }
  }
}
